import { Route, Switch, } from 'react-router-dom';

import Home from '../pages/Home';
import Login from '../pages/Login';
import AuthenticatedRoute from '../components/AuthenticatedRoute';
import CadastrarProva from "../pages/CadastrarProva/index.jsx";



export default function Routes(){
    return(
        <Switch>               
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <AuthenticatedRoute exact path="/home" component={Home} />
          <AuthenticatedRoute exact path="/cadastrar-prova" component={CadastrarProva} />
            
        </Switch>
    )
}
    
